import React from 'react';
import Icon from "@scentregroup/ui/components/icon";
import { getCentreAcknowledgementCountry } from '@scentregroup/shared/helpers/get-centre-acknowledgement';
import { makeMailUrl } from '../../helpers';
import { conciergeTitle } from '../../helpers/concierge';
import ExternalLink from '../external-link';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const CentreDetails = _ref => {
  let {
    centre,
    onFindACentre
  } = _ref;
  const country = getCentreAcknowledgementCountry(centre.slug);
  return /*#__PURE__*/_jsxs("div", {
    className: style.centreDetails,
    "data-id": "universal-footer_centre-details_CentreDetails_div",
    children: [/*#__PURE__*/_jsxs("div", {
      className: style.centreInfo,
      "data-id": "universal-footer_centre-details_CentreDetails_div_div_1",
      children: [/*#__PURE__*/_jsxs("div", {
        className: style.centreRow,
        "data-id": "universal-footer_centre-details_CentreDetails_div_div_2",
        children: [/*#__PURE__*/_jsx("span", {
          className: style.centreName,
          "data-id": "universal-footer_centre-details_CentreDetails_div_span",
          children: centre.title
        }), onFindACentre && /*#__PURE__*/_jsx("button", {
          className: style.changeCentre,
          onClick: onFindACentre,
          "data-id": "universal-footer_centre-details_CentreDetails_button",
          children: "Change\xA0centre"
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: style.centreAddress,
        "data-id": "universal-footer_centre-details_CentreDetails_div_div",
        children: [!!country && /*#__PURE__*/_jsxs(_Fragment, {
          children: [country, " ", /*#__PURE__*/_jsx("br", {
            "data-id": "universal-footer_centre-details_CentreDetails_br"
          })]
        }), centre.physicalAddress, " ", /*#__PURE__*/_jsx("br", {
          "data-id": "universal-footer_centre-details_CentreDetails_div_br_7"
        }), centre.suburb, " ", centre.state, " ", centre.postcode, " ", /*#__PURE__*/_jsx("br", {
          "data-id": "universal-footer_centre-details_CentreDetails_div_br_8"
        }), /*#__PURE__*/_jsx(ExternalLink, {
          url: "tel:".concat(centre.telephoneNumber),
          "data-id": "universal-footer_centre-details_CentreDetails_div_ExternalLink",
          children: centre.telephoneNumber
        })]
      }), /*#__PURE__*/_jsx(ExternalLink, {
        url: makeMailUrl(centre.emailAddress),
        className: style.contactConcierge,
        "data-id": "universal-footer_centre-details_CentreDetails_div_ExternalLink_10",
        children: "Contact ".concat(centre.title, " ").concat(conciergeTitle(centre.country, centre.slug))
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: style.contactLinks,
      "data-test-id": "contact-links",
      "data-id": "universal-footer_centre-details_CentreDetails_div_div",
      children: centre.contactLinks.filter(_ref2 => {
        let {
          type
        } = _ref2;
        return type !== 'twitter';
      }).map(contact => contact.url && /*#__PURE__*/_jsx(ExternalLink, {
        url: contact.url,
        "aria-label": "Go to Westfield ".concat(centre.title, "'s ").concat(contact.type),
        "data-id": "universal-footer_centre-details_CentreDetails_ExternalLink",
        children: /*#__PURE__*/_jsx(Icon, {
          type: contact.type,
          size: "medium",
          className: style.socialLogo,
          "data-id": "universal-footer_centre-details_CentreDetails_ExternalLink_Icon"
        })
      }, contact.type))
    })]
  });
};